// src/components/operationCenter/widgets/token/derivatives/TwFundingRateChartWidget.tsx
import React from "react";
import type { WidgetProps, TokenWidgetConfig } from "@/types/dashboard";
import { TokenWidgetWrapper } from "../TokenWidgetWrapper";
import { TokenWidgetConfigPanel } from "../TokenWidgetConfig";
import TokenFundingRateChart from "@/components/tokenPage/derivatives/TokenFundingRateChart";

const TwFundingRateChartWidget: React.FC<WidgetProps<TokenWidgetConfig>> = ({
  widget,
  onConfigChange,
}) => {
  const config = widget.config as TokenWidgetConfig;
  return (
    <TokenWidgetConfigPanel config={config} onConfigChange={onConfigChange} widgetType={widget.type}>
      {/* TokenFundingRateChart uses its own hooks — no domain provider needed */}
      <TokenWidgetWrapper ticker={config.ticker} providers={[]}>
        <TokenFundingRateChart ticker={config.ticker.toUpperCase()} />
      </TokenWidgetWrapper>
    </TokenWidgetConfigPanel>
  );
};

export default TwFundingRateChartWidget;
